import {helpSystemInterface} from '../apps/outof195/shared/help-system.interface'

export const helpSystemState = {
    defaultState: {
        helpSystem: {...helpSystemInterface},
        helpSystemLoaded: false,
        helpSystemError: null,
    },
    actions: {
        setHelpSystem: (help, state) => ({...state, helpSystem: help}),
        setHelpSystemLoaded: (loaded, state) => ({...state, helpSystemLoaded: loaded}),
        setHelpSystemError: (error, state) => ({...state, helpSystemError: error}),
    },
}
